import React from 'react';
import { Search } from 'lucide-react';

interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export function SearchBar({ searchQuery, setSearchQuery }: SearchBarProps) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-accessible-gray-400 dark:text-white/60" aria-hidden="true" />
      <input
        type="text"
        placeholder="Szukaj ..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-accessible-gray-200 dark:border-accessible-gray-700 rounded-lg focus:ring-2 focus:ring-accessible-red-600 focus:border-transparent bg-white dark:bg-accessible-gray-700 form-input placeholder-accessible-gray-500 dark:placeholder-white/60 text-accessible-gray-900 dark:text-white"
        aria-label="Wyszukaj zwierzaka"
      />
    </div>
  );
}